class OptionHelpers {
  status() {
    return [
      { value: "good", label: "Good" },
      { value: "bad", label: "Bad" },
    ]
  }

  work_status() {
    return [
      { value: "OPEN", label: "Open" },
      { value: "SUSPENDED", label: "Suspended" },
      { value: "STOPPED", label: "Stopped" },
      { value: "UNCLOSED", label: "Unclosed" },
      { value: "CLOSED", label: "Closed" },
      { value: "COMPLETED", label: "Completed" },
    ]
  }

  part_condition() 
  {
    return [
      { value: "good", label: "Good" },
      { value: "bad", label: "Bad" },
    ]
  }

  part_condition_2() 
  {
    return [
      { value: "good", label: "Good" },
      { value: "bad", label: "Bad" },
      { value: "not_available", label: "Not Available" },
    ]
  }

  location_type()
  {
    return [
      { value: "warehouse", label: "Warehouse" },
      { value: "user", label: "Service Engineer" },
    ]
  }

  location_type_nr()
  {
    return [
      { value: "warehouse", label: "Warehouse" },
      { value: "user", label: "Service Engineer" },
      { value: "repair", label: "Repair Engineer" },
    ]
  }

  list_of_hex_of_soft_color() {
    return [
      {
        bg: "rgba(255, 99, 132, 0.2)",
        border: "rgba(255, 99, 132, 1)",
      },
      {
        bg: "rgba(54, 162, 235, 0.2)",
        border: "rgba(54, 162, 235, 1)",
      },
      {
        bg: "rgba(255, 206, 86, 0.2)",
        border: "rgba(255, 206, 86, 1)",
      },
      {
        bg: "rgba(75, 192, 192, 0.2)",
        border: "rgba(75, 192, 192, 1)",
      },
      {
        bg: "rgba(153, 102, 255, 0.2)",
        border: "rgba(153, 102, 255, 1)",
      },
      {
        bg: "rgba(255, 159, 64, 0.2)",
        border: "rgba(255, 159, 64, 1)",
      },

      {
        bg: "rgba(255, 99, 132, 0.2)",
        border: "rgba(255, 99, 132, 1)",
      },
      {
        bg: "rgba(54, 162, 235, 0.2)",
        border: "rgba(54, 162, 235, 1)",
      },
      {
        bg: "rgba(255, 206, 86, 0.2)",
        border: "rgba(255, 206, 86, 1)",
      },
      {
        bg: "rgba(75, 192, 192, 0.2)",
        border: "rgba(75, 192, 192, 1)",
      },
      {
        bg: "rgba(153, 102, 255, 0.2)",
        border: "rgba(153, 102, 255, 1)",
      },
      {
        bg: "rgba(255, 159, 64, 0.2)",
        border: "rgba(255, 159, 64, 1)",
      },

      {
        bg: "rgba(255, 99, 132, 0.2)",
        border: "rgba(255, 99, 132, 1)",
      },
      {
        bg: "rgba(54, 162, 235, 0.2)",
        border: "rgba(54, 162, 235, 1)",
      },
      {
        bg: "rgba(255, 206, 86, 0.2)",
        border: "rgba(255, 206, 86, 1)",
      },
      {
        bg: "rgba(75, 192, 192, 0.2)",
        border: "rgba(75, 192, 192, 1)",
      },
      {
        bg: "rgba(153, 102, 255, 0.2)",
        border: "rgba(153, 102, 255, 1)",
      },
      {
        bg: "rgba(255, 159, 64, 0.2)",
        border: "rgba(255, 159, 64, 1)",
      },

      {
        bg: "rgba(255, 99, 132, 0.2)",
        border: "rgba(255, 99, 132, 1)",
      },
      {
        bg: "rgba(54, 162, 235, 0.2)",
        border: "rgba(54, 162, 235, 1)",
      },
      {
        bg: "rgba(255, 206, 86, 0.2)",
        border: "rgba(255, 206, 86, 1)",
      },
      {
        bg: "rgba(75, 192, 192, 0.2)",
        border: "rgba(75, 192, 192, 1)",
      },
      {
        bg: "rgba(153, 102, 255, 0.2)",
        border: "rgba(153, 102, 255, 1)",
      },
      {
        bg: "rgba(255, 159, 64, 0.2)",
        border: "rgba(255, 159, 64, 1)",
      },

      {
        bg: "rgba(255, 99, 132, 0.2)",
        border: "rgba(255, 99, 132, 1)",
      },
      {
        bg: "rgba(54, 162, 235, 0.2)",
        border: "rgba(54, 162, 235, 1)",
      },
    ]
  }
}

export default new OptionHelpers()
